import { PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer, Tooltip } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../ui/chart';

export default function SlaRadialGauge({
  value,
  label = 'Overdue %',
  fill = '#ef4444',
}: {
  value: number;
  label?: string;
  fill?: string;
}) {
  const data = [{ name: label, value, fill }];
  return (
    <ChartContainer className="h-64">
      <ResponsiveContainer>
        <RadialBarChart innerRadius="70%" outerRadius="100%" data={data} startAngle={180} endAngle={0}>
          <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
          <RadialBar dataKey="value" cornerRadius={8} background={{ fill: '#e5e7eb' }} />
          <Tooltip content={<ChartTooltipContent />} />
        </RadialBarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}


